import allDrugNames from '../data/drugNames.json';

const RXNAV_BASE = 'https://rxnav.nlm.nih.gov/REST';

/**
 * Filters the local drug name list — no API call, instant results.
 * Shows names that START WITH the query first, then names that contain it.
 */
export function getSuggestions(query) {
  const q = query.toLowerCase();

  const startsWith = [];
  const contains = [];

  for (const name of allDrugNames) {
    const lower = name.toLowerCase();
    if (lower.startsWith(q)) {
      startsWith.push(name);
    } else if (lower.includes(q)) {
      contains.push(name);
    }
    if (startsWith.length + contains.length >= 30) break;
  }

  return [...startsWith, ...contains].slice(0, 15);
}

/**
 * Fetches available dosage forms for a given RxCUI.
 * Returns SCD (generic) and SBD (brand) concepts — e.g. "Lisinopril 10 MG Oral Tablet".
 * Only called once when the user selects a drug.
 */
export async function getDosages(rxcui) {
  const res = await fetch(
    `${RXNAV_BASE}/rxcui/${rxcui}/related.json?tty=SCD+SBD`
  );
  if (!res.ok) throw new Error(`RxNav request failed: ${res.status}`);
  const data = await res.json();

  const groups = data?.relatedGroup?.conceptGroup || [];
  const seen = new Set();
  const dosages = [];

  for (const group of groups) {
    for (const p of group.conceptProperties || []) {
      if (!seen.has(p.name)) {
        seen.add(p.name);
        dosages.push({ name: p.name, rxcui: p.rxcui });
      }
    }
  }

  return dosages.sort((a, b) => a.name.localeCompare(b.name));
}

/**
 * Looks up the RxCUI for a drug name.
 * The display name always comes from the local list — this only fetches the ID.
 */
export async function getRxCUI(name) {
  const res = await fetch(
    `${RXNAV_BASE}/rxcui.json?name=${encodeURIComponent(name)}&search=1`
  );
  if (!res.ok) throw new Error(`RxNav request failed: ${res.status}`);
  const data = await res.json();
  const ids = data?.idGroup?.rxnormId || [];
  return ids[0] ?? null;
}
